import { defineComponent as _defineComponent } from 'vue'
import { computed, ComputedRef, onMounted, ref } from 'vue';
import moment from 'moment';
import useStore from '@/utils/store/common';
import { INavigation } from '@/store/modules/devices/types';
import { FilterGroup } from 'ctp-filter-group-management';
import AddBookmarkDialog from '@/components/common/Filters/components/AddBookmarkDialog.vue';
import FilterBookmarks from '@/components/common/Filters/components/FilterBookmarks.vue';
import FilterItem from '@/components/common/Filters/components/FilterItem.vue';
import { colors } from '@/constants/theme/colors';
import './styles/history-filter.scss';


export default /*#__PURE__*/_defineComponent({
  __name: 'HistoryFilter',
  props: {
  redirectionID: {
    type: String,
    default: ''
  }
},
  setup(__props) {

const props = __props;

const store = useStore();



const deviceTypes = { device_types: ['obu5gen', 'vdolink'] };

const getNavigationConfiguration: ComputedRef<INavigation> = computed(() => store.getters['history/getNavigationConfiguration']);
const getFiltersMeta: ComputedRef<any> = computed(() => store.getters['history/getFiltersMeta']);
const displayDiffDate = (seconds: number) => moment().subtract(seconds, 'seconds').format('DD/MM/YYYY');
const displayDate = (timestamp: number) => moment.unix(timestamp).format('DD/MM/YYYY');

const displayMoreFilters = ref(false);
const activeFiltersCount = ref(0);
const appliedFilters = ref<{ [key: string]: any }[]>([]);
const selectedFilters = ref<{ id: string, values: string[] }[]>([]);
const multiSearch = ref('');
const subCategories = ref<string[]>([]);
const resetedFilters = ref<string[]>([]);
const resetMe = ref('');
const reset = ref(false);

// Used to reset all filters with a TreeMenu component. FilterItem has a :key that resets the component when changed
const treeMenuKeyState = ref(0);
const treeMenuKeyCmd = ref(1);
const treeMenuKeyEvt = ref(2);

function getFilter(name: string) {
  const data = getFiltersMeta.value.find((f: { name: string; }) => f.name === name);
  if (data) {
    return { ...data };
  }
  return {};
}

function applyFilters(fetchHistory = true) {
  const filters: {[key: string]: any} = {};
  resetMe.value = '';
  resetedFilters.value = [];
  // Push all selected filters
  if (selectedFilters.value.length > 0) {
    selectedFilters.value.forEach((item) => {
      filters[item.id] = item.values;
    });
  }
  // Push subCategories filters
  if (subCategories.value.length > 0) {
    filters.subCategories = subCategories.value.join();
  }
  // Push multisearch bar values
  if (multiSearch.value !== '') {
    activeFiltersCount.value = 1;
    filters.identifierMatchers = multiSearch.value.replace(/ /g, '').split(',');
  }
  const newNavigationConfiguration = {
    ...getNavigationConfiguration
  };
  newNavigationConfiguration.value.filters = filters;
  newNavigationConfiguration.value.start = 0;
  appliedFilters.value = Object.entries(filters).map(([key, value]) => ({ [key]: value }));
  if (fetchHistory) store.dispatch('history/fetchHistory', { ...newNavigationConfiguration.value });
}

onMounted(async () => {
  await store.dispatch('history/fetchFiltersMeta');
  if (props.redirectionID && props.redirectionID !== '') {
    multiSearch.value = props.redirectionID;
    applyFilters();
  }
});

function resetFilterValues() {
  selectedFilters.value = [];
  multiSearch.value = '';
  subCategories.value = [];
  activeFiltersCount.value = 0;
  appliedFilters.value = [];
  resetedFilters.value = [];
  reset.value = true;
  treeMenuKeyState.value++;
  treeMenuKeyCmd.value++;
  treeMenuKeyEvt.value++;
}

function resetFilters() {
  resetFilterValues();
  const newNavigationConfiguration = {
    ...getNavigationConfiguration
  };
  newNavigationConfiguration.value.filters = {};
  newNavigationConfiguration.value.start = 0;
  store.dispatch('history/updateNavigation', { ...newNavigationConfiguration.value });
}

function updateFilters(key: string, val: string[]) {
  const index = selectedFilters.value.findIndex(item => item.id === key);
  if (index !== -1) {
    selectedFilters.value[index].values = val;
  } else {
    selectedFilters.value.push({ id: key, values: val });
  }
}

const triggerReset = (filterID: string) => {
  resetMe.value = filterID;
  resetedFilters.value.push(filterID);
};

function removeFilter(f: any) {
  if (f.identifierMatchers) {
    multiSearch.value = '';
  } else if (f.subCategories) {
    subCategories.value = [];
    treeMenuKeyState.value++;
    treeMenuKeyCmd.value++;
    treeMenuKeyEvt.value++;
  } else {
    selectedFilters.value = selectedFilters.value.filter(item => item.id !== Object.keys(f)[0]); // enlève les chip
  }
  triggerReset(Object.keys(f)[0]);
}

function applyBookmark(bookmark: FilterGroup) {
  resetFilterValues();
  Object.entries(JSON.parse(bookmark.filters)).forEach(([key, values]: any) => {
    if (key === 'device_ids') {
      multiSearch.value = values.join(',');
    } else {
      selectedFilters.value.push({ id: key, values });
    }
  });
  applyFilters();
}

const isReset = computed(() => (f: any) => resetedFilters.value.includes(Object.keys(f)[0]));

function toggleMoreFilters() {
  displayMoreFilters.value = !displayMoreFilters.value;
}

function addHistoryCat(cat: string) {
  subCategories.value.push(cat);
}

function delHistoryCat(cat: string) {
  subCategories.value = subCategories?.value.filter(item => item !== cat);
}

return { __sfc: true,store, props, deviceTypes, getNavigationConfiguration, getFiltersMeta, displayDiffDate, displayDate, displayMoreFilters, activeFiltersCount, appliedFilters, selectedFilters, multiSearch, subCategories, resetedFilters, resetMe, reset, treeMenuKeyState, treeMenuKeyCmd, treeMenuKeyEvt, getFilter, applyFilters, resetFilterValues, resetFilters, updateFilters, triggerReset, removeFilter, applyBookmark, isReset, toggleMoreFilters, addHistoryCat, delHistoryCat, AddBookmarkDialog, FilterBookmarks, FilterItem, colors }
}

})